/**
 * Le sfide di piattaforma di UNA lista di giochi (la chiave SFIDE di un gioco nella v3, v. `PannelloSfide`): quelle col `gameId` fra `giochi`. `giochi` assente = tutte, com'e' in Amici
 * (l'identita': nessuna copia, nessun filtro). Un `gameId` che non e' nell'insieme non passa, nemmeno se il catalogo non lo conosce.
 */
export function perGioco<T extends { gameId: string }>(lista: readonly T[], giochi: ReadonlySet<string> | undefined): readonly T[] {
  return giochi === undefined ? lista : lista.filter((c) => giochi.has(c.gameId));
}
